import _get from 'lodash/get';
import { LatLngExpression } from 'leaflet';
import { DEFAULT_ZOOM } from '@lib/components/Map/constants';

type CenterMapOptions = {
  res: any;
  mapRef?: React.RefObject<L.Map | null>;
};

export function handleCenterMap({ res, mapRef }: CenterMapOptions) {
  const lat = _get(res, ['data', 'data', 'lat']);
  const lon = _get(res, ['data', 'data', 'lon']);

  if (lat !== undefined && lon !== undefined && mapRef?.current) {
    mapRef.current.setView({ lng: lon, lat } as LatLngExpression, DEFAULT_ZOOM);
  }
}
